module.exports = __webpack_public_path__ + "img/inception.9d622916.png";